<template>
   <div class="footer_bar">
        <dl v-for="(item,index) in data" :class="{active:index===sy}" :key="index" class="clearfix">
            <router-link :to="item.url">
                <dd class="icon" :class = "index === sy ? item.activeIcon : item.icon"></dd>
                <!-- <dt> -->
                <dd>{{item.title}}</dd>
                <!-- </dt> -->
            </router-link>
        </dl>
    <!-- <div class="clearfix"></div> -->
  </div>
</template>
<script>
export default {
  name: 'Footer',
  props: ['sy'],
  data () {
    return {
      data: [
        {
          'title': '首页',
          'icon': 'iconIndex',
          'activeIcon': 'activeIndex',
          'url': '/'
        },
        {
          'title': '商品',
          'icon': 'iconShop',
          'activeIcon': 'activeShop',
          'url': '/shopptyh/0'
        },
        {
          'title': '绑定样本',
          'icon': 'iconStyle',
          'activeIcon': 'activeStyle',
          'url': '/style'
        },
        {
          'title': '积分商城',
          'icon': 'iconPoint',
          'activeIcon': 'activePoint',
          'url': '/pointShop'
        },
        {
          'title': '我的',
          'icon': 'iconMy',
          'activeIcon': 'activeMy',
          'url': '/home'
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
    .footer_bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 7px 0 5px;
        background-color: #fff;
        z-index: 99;
        box-shadow: 0 -2px 2px 0 rgba(204,204,204,.25);
        dl{
            width: 20%;
            float: left;
            text-align: center;
            font-size: 10px;
                .icon{
                    display:block;
                    width:20px;
                    height:20px;
                    margin:0 auto 2px;
                    -webkit-background-size:cover;
                    -size:cover;
                    background-repeat:no-repeat;
                }
                .iconIndex{
                    background-image:url(../assets/images/fi1.png);
                    background-position:0 -20px;
                }
                .iconShop{
                    background-image:url(../assets/images/fi2.png);
                    background-position:0 -20px;
                }
                .iconStyle{
                    background-image:url(../assets/images/fi3.png);
                    background-position:0 -20px;
                }
                .iconPoint{
                    background-image:url(../assets/images/fi4.png);
                    background-position:0 -20px;
                }
                .iconMy{
                    background-image:url(../assets/images/fi5.png);
                    background-position:0 -20px;
                }
                .activeIndex{
                    background-image:url(../assets/images/fi1.png);
                    background-position:0 0;
                }
                .activeShop{
                    background-image:url(../assets/images/fi2.png);
                    background-position:0 0;
                }
                .activeStyle{
                    background-image:url(../assets/images/fi3.png);
                    background-position:0 0;
                }
                .activePoint{
                    background-image:url(../assets/images/fi4.png);
                    background-position:0 0;
                }
                .activeMy{
                    background-image:url(../assets/images/fi5.png);
                    background-position:0 0;
                }
        }
        .active{
            dd{
                color:#60b0e3;
                font-size: 10px;
            }
        }
    }
</style>
